import { api } from './client.js';

const root = '/admin/staff-notes';

export const staffNotesApi = {
  list: (params) => api.get(root, { query: params }),
  create: (body) => api.post(root, body),
  update: (id, body) => api.patch(`${root}/${id}`, body),
  remove: (id) => api.delete(`${root}/${id}`)
};
